import axios from 'axios';
import prepareQueryString from '@/utils/prepareQueryString';
import { subject as an } from '@casl/ability';
import { adminPath } from '@/api/helpers/apiPath';

export default {
  getUsersNotes(id, params) {
    return axios.get(adminPath(`/users/${id}/notes?`) + prepareQueryString(params)).then((response) => {
      return {
        notes: response.data.map((note) => an('Note', note)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  createUsersNote(userId, data) {
    return axios
      .post(adminPath(`/users/${userId}/notes`), {
        ...data,
      })
      .then((response) => an('Note', response.data));
  },
  getClientsNotes(id, params) {
    return axios.get(adminPath(`/clients/${id}/notes?`) + prepareQueryString(params)).then((response) => {
      return {
        notes: response.data.map((note) => an('Note', note)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  createClientsNote(userId, data) {
    return axios
      .post(adminPath(`/clients/${userId}/notes`), {
        ...data,
      })
      .then((response) => an('Note', response.data));
  },
  getComplianceDocumentsNotes(id, params) {
    return axios.get(adminPath(`/compliance_documents/${id}/notes?`) + prepareQueryString(params)).then((response) => {
      return {
        notes: response.data.map((note) => an('Note', note)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  createComplianceDocumentsNote(complianceDocumentId, data) {
    return axios
      .post(adminPath(`/compliance_documents/${complianceDocumentId}/notes`), {
        ...data,
      })
      .then((response) => an('Note', response.data));
  },
  getWorkOrdersNotes(id, params) {
    return axios.get(adminPath(`/work_orders/${id}/notes?`) + prepareQueryString(params)).then((response) => {
      return {
        notes: response.data.map((note) => an('Note', note)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  createWorkOrdersNote(workOrderId, data) {
    return axios
      .post(adminPath(`/work_orders/${workOrderId}/notes`), {
        ...data,
      })
      .then((response) => an('Note', response.data));
  },
  getLocationsNotes(id, params) {
    return axios.get(adminPath(`/locations/${id}/notes?`) + prepareQueryString(params)).then((response) => {
      return {
        notes: response.data.map((note) => an('Note', note)),
        total: response.headers['x-pagination'] && JSON.parse(response.headers['x-pagination']).total,
      };
    });
  },
  createLocationsNote(locationId, data) {
    return axios
      .post(adminPath(`/locations/${locationId}/notes`), {
        ...data,
      })
      .then((response) => an('Note', response.data));
  },
  updateNote(id, data) {
    return axios
    .patch(adminPath(`/notes/${id}`), {
      ...data,
    })
    .then((response) => an('Note', response.data));
  },
};
